<div class="container">
  <app-drawer-workorder-title
    title="{{ 'workorder.assign-specialists.drawer-title' | translate }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>
  <div>
    <div class="search">
      <input
        #search
        class="search-text"
        type="search"
        placeholder="{{ 'workorder.assign-specialists.search' | translate }}"
        (keyup)="updateSearchTerm(search.value)"
      />
      <mat-icon class="search-icon">search</mat-icon>
    </div>
    <ul>
      <li
        tabindex="0"
        (click)="toggleEmployeeSelected(employee)"
        (keyup.enter)="toggleEmployeeSelected(employee)"
        *ngFor="let employee of availableEmployees$ | async"
      >
        <div class="employee-info">
          {{ employee.name }}
          <p class="nationalId">{{ employee.nationalId }}</p>
        </div>
        <mat-icon class="icon">add</mat-icon>
      </li>
    </ul>

    <h3>
      {{ "workorder.assign-specialists.assigned-specialists" | translate }}
    </h3>

    <ul>
      <li
        tabindex="0"
        (click)="
          toggleEmployeeSelected(
            assignEmployee.employee,
            assignEmployee.visitCount
          )
        "
        (keyup.enter)="
          toggleEmployeeSelected(
            assignEmployee.employee,
            assignEmployee.visitCount
          )
        "
        *ngFor="let assignEmployee of assignedEmployees$ | async"
        [ngClass]="{ employeeHasVisits: assignEmployee.visitCount > 0 }"
      >
        <div class="employee-info">
          {{ assignEmployee.employee.name }}
          <p class="nationalId">{{ assignEmployee.employee.nationalId }}</p>
        </div>
        <mat-icon class="icon" *ngIf="!assignEmployee.visitCount"
          >remove</mat-icon
        >
        <div class="visitCount" *ngIf="assignEmployee.visitCount">
          {{ assignEmployee.visitCount }}
          {{ "workorder.assign-specialists.visits" | translate }}
        </div>
      </li>
    </ul>
  </div>
  <app-drawer-workorder-actions
    class="buttons"
    confirmButtonName="{{ 'workorder.assign-specialists.save' | translate }}"
    (clickConfirmButtonEvent)="save()"
    (clickCancelButtonEvent)="close()"
  ></app-drawer-workorder-actions>
</div>
